module.exports = __webpack_public_path__ + "img/carousel-back.f8f4038e.svg";